import { Theme } from './reducers/rootReducer';

export const changeThemeAction = (theme: Theme) => {
    return {
        type: 'CHANGE_THEME',
        payload: theme,
    };
};

export const changeLanguage = (language: string) => {
    return {
        type: 'CHANGE_LANGUAGE',
        payload: language,
    };
};

/**
 * 購入済みチケット画面において、タブの変更を記録する。
 * @param {*} activekey
 * @returns
 */
export const changePurchaseActiveKey = (activekey: string) => {
    return {
        type: 'CHANGE_PURCHASED_ACTIVEKEY',
        payload: activekey,
    };
};
/**
 * サービスワーカー更新の実行
 *
 * @param {Function} updateFunction
 * @returns
 */
export const updateAppHandle = (updateFunction: ((reloadPage?: boolean) => Promise<void>) | null) => {
    return {
        type: 'SW_UPDATE',
        payload: updateFunction,
    };
};
